import * as React from 'react';
import styled from 'styled-components';
import { Button } from '../../Button';
import { Container } from '../../Modal/ConfirmModal';
import { PageHeaderText } from '../../Typography';
import { DrawerModal } from './DrawerModal';

interface ConfirmDrawerModalProps {
  onOk: () => void;
  onCancel: () => void;
  title: string;
  icon: any;
  children: any;
  okButtonText: string;
  cancelButtonText: string;
  isReverse?: boolean;
  closable?: boolean;
  visible: boolean;
}

const StyledButton = styled(Button)`
  width: fit-content;
  min-width: 120px;
  height: 40px;
  border-radius: 8px;
`;

export const ConfirmDrawerModal = (props: ConfirmDrawerModalProps) => {
  const {
    onOk,
    onCancel,
    title,
    children,
    icon,
    visible,
    okButtonText,
    cancelButtonText,
    isReverse = false,
    closable = true,
  } = props;

  const FooterButtonRevert = [
    <StyledButton isMobile style={{ marginRight: 16 }} key="submit" onClick={onOk}>
      {okButtonText}
    </StyledButton>,
    <StyledButton isMobile type="primary" key="back" onClick={onCancel}>
      {cancelButtonText}
    </StyledButton>,
  ];

  const FooterButton = [
    <StyledButton isMobile style={{ marginRight: 16 }} key="back" onClick={onCancel}>
      {cancelButtonText}
    </StyledButton>,
    <StyledButton isMobile key="submit" type="primary" onClick={onOk}>
      {okButtonText}
    </StyledButton>,
  ];

  return (
    <DrawerModal visible={visible} closable={closable} onClose={onCancel} footer={false}>
      <Container>
        {icon}
        <PageHeaderText>{title}</PageHeaderText>
        <div />
        <div>{children}</div>
      </Container>
      {isReverse ? FooterButtonRevert : FooterButton}
    </DrawerModal>
  );
};
